var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"round-time-bar",style:('--duration: '+_vm.countdown+';'),attrs:{"data-style":"smooth"}},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }